'use client';

import ScrollFade from '@/components/ui/ScrollFade/ScrollFade';
import { montserrat } from '@/lib/font';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { useAtom } from 'jotai';
import { localeAtom } from '../../atoms/localAtom';
import type { LotteryBenefit, LotteryCustomOption, LotteryDrawHistoryLineup } from '../../types';
import LotteryGoodsList from '../LotteryGoodsList/LotteryGoodsList';
import styles from './LotteryBenefitList.module.scss';

function LotteryBenefitList({
  lotteryStatus,
  benefitList,
  lotteryDrawHistory,
  customOptions,
}: {
  lotteryStatus: string;
  benefitList: Array<LotteryBenefit>;
  lotteryDrawHistory?: Array<LotteryDrawHistoryLineup>;
  customOptions?: LotteryCustomOption;
}) {
  const [locale] = useAtom(localeAtom);
  return (
    <>
      <ul className={styles.componentStyle}>
        {benefitList.map((benefit) => (
          <ScrollFade tag={'li'} key={`benefit_${benefit.id}`}>
            <div className={styles.itemCard}>
              {/* 特典 */}
              {benefit.benefitMultiDrawCount > 0 && (
                <div className={styles.benefitWrapper}>
                  <span className={montserrat.className}>{benefit.benefitMultiDrawCount}</span>
                  <small>連特典</small>
                </div>
              )}
              {/* 景品ラベル名 */}
              <div className={`${styles.itemName} ${utilsStyles.textLarge} ${utilsStyles.textBold}`}>
                {locale === 'en' ? benefit.categoryName_en : benefit.name}
              </div>
              {/* 景品ラベル詳細 */}
              <div className={`${styles.itemDescription} ${utilsStyles.textSmall}`}>
                {locale === 'en' ? benefit.description_en : benefit.description}
              </div>
              {/* 景品一覧 */}
              <LotteryGoodsList
                lotteryStatus={lotteryStatus}
                goodsList={benefit.goods}
                linupId={benefit.id}
                lotteryDrawHistory={lotteryDrawHistory}
                liKeyPrefix={'benefit_goods'}
                customOptions={customOptions}
              />
            </div>
          </ScrollFade>
        ))}
      </ul>
    </>
  );
}

export default LotteryBenefitList;
